<template>
  <form class="form-group label-floating has-warning">
    <div class="md-layout">
      <span class="md-layout-item note" style="white-space: normal;">
        <vue-mathjax
          v-if="config.attributes.mathjax"
          :formula="tx(config.attributes.model)"
        ></vue-mathjax>
        <span
          v-else
          class="md-caption"
          v-html="tx(config.attributes.model)"
        ></span>
        <helpWidget style="padding-left: 2%;" :help="help_key"></helpWidget
      ></span>
    </div>

    <div
      class="slider slider-warning"
      :model="value"
      id="pips-range-vertical-rtl"
    ></div>
  </form>
</template>
<script>
import { VueMathjax } from "vue-mathjax";
import inputComponentMixin from "ireal-vue/mixins/input-component-mixin.js";
import Bus from "../services/bus.js";
import fillins from "../fillins.js";
//import Slider from "vue-material-kit-pro/src/components/Slider.vue";
import noUiSlider from "nouislider";
//import wNumb from "wnumb";

export default {
  name: "slider-component",
  mixins: [inputComponentMixin],
  components: { "vue-mathjax": VueMathjax },
  data() {
    return {};
  },

  created() {
    //this.range.max = this.slider_max;
  },

  async mounted() {
    // si l'option pips est indiquée en attribut on rajoute l'option pips de nouislider
    // l'option pips n'est pas intégrée dans material kit pro
    this.value = 25;

    var pipsRangeVerticalRtl = document.getElementById(
      "pips-range-vertical-rtl"
    );
    noUiSlider.create(pipsRangeVerticalRtl, {
      range: this.list_options,
      start: 0,
      tooltips: true,
      orientation: "vertical",
      direction: "rtl",
      pips: {
        mode: "positions",
        values: [0, 25, 50, 75, 100],
        density: 3
      }
    });
    pipsRangeVerticalRtl.noUiSlider.on("update", (values, handle) => {
      this.value = parseFloat(values[handle]);
    });

/*    Bus.$on("value-changed", payload => {
      // for dependant slider, value is adjust ( when slider are dependants ,
      //attributes_minmodel or maxmodel represent the name of other slider )
    });*/
  },

  computed: {
    step() {
      return parseFloat(this.config.attributes.step);
    },

    list_options() {
      // build on array of values from min,max and step element
      var options = {};
      var tab_options =
        this.config.attributes.options != undefined
          ? this.config.attributes.options.split("|").map(v => parseFloat(v))
          : fillins.xah_range(
              parseFloat(this.config.attributes.min),
              parseFloat(this.config.attributes.max),
              this.step
            );
      var tab_options_max = tab_options.length - 1;
      for (var i in tab_options) {
        var j = parseInt(i);
        if (i == 0) {
          options["min"] = [
            tab_options[i],
            tab_options[j + 1] - tab_options[j]
          ];
        } else if (i == tab_options_max) {
          options["max"] = tab_options[tab_options_max];
        } else {
          var purcent = parseInt((i / tab_options_max) * 100) + "%";

          options[purcent] = [
            tab_options[i],
            tab_options[j + 1] - tab_options[j]
          ];
        }
      }
      return options;
    },
    list_range() {
      var list_range = {};
      if (this.pips_slider == "border") {
        list_range["min"] = [parseFloat(this.config.attributes.min)];
        list_range["max"] = [parseFloat(this.config.attributes.max)];
      } else {
        for (var i in this.list_positions) {
          if (i == 0) {
            list_range["min"] = [
              this.list_options[i],
              this.list_options[1] - this.list_options[i]
            ];
          } else if (i == this.list_positions.length - 1) {
            list_range["max"] = [this.list_options[i]];
          } else
            list_range[this.list_positions[i]] = [
              this.list_options[i],
              this.list_options[i] - this.list_options[i - 1]
            ];
        }
      }
      return list_range;
    },
    countDecimal() {
      var decimal = 0;
      for (var i in this.list_range) {
        if (!Number.isInteger(this.list_range[i][0])) {
          decimal = this.list_range[i][0].toString().split(".")[1];
          decimal = decimal.length;
        }
      }
      return decimal;
    },
    format() {
      // return number format default because string option are rare in slider element.

      return this.config.attributes.format
        ? this.config.attributes.format
        : "number";
    }
  }
};
</script>
<style scoped>
.note {
  color: rgba(0,0,0,0.54));
  font-size: 0.8em !important;
  font-weight: 400 !important;
  font-family: 'Roboto', sans-serif !important;
  font-style:lighter !important;
  text-align:left !important;
}
.note span{
  font-style:normal !important;
}
.MathJax_Display {
  text-align: left !important;
}
#MathJax-Span{
  font-style:normal !important;
}
.noUi-vertical{
  width:2px;
  height:300px;
}
.noUi-handle{
  width:5px !important;
  height:5px !important;
}
#pips-range-vertical-rtl{
  margin-left: auto;
  margin-right: auto;
}
</style>
